import { gql } from '@apollo/client/core';

export const BULK_UPDATE_CURRICULUM = gql`
  mutation BulkUpdateCurriculum(
    $ids: [ID!]!, $status: String, $course_registration_level: String, $semester: Int,
    $programme_id: ID, $programme_module_id: ID, $remove_from_module: Boolean
  ) {
    bulkUpdateCurriculum(
      ids: $ids, status: $status, course_registration_level: $course_registration_level,
      semester: $semester, programme_id: $programme_id, programme_module_id: $programme_module_id,
      remove_from_module: $remove_from_module
    ) {
      success message
    }
  }
`;

export const CLONE_MODULES_WITH_COURSES = gql`
  mutation CloneModulesWithCourses($input: cloneProgrammeModulesInput!) {
    cloneProgrammeModules(input: $input) { created skipped modules { id name } }
  }
`;
